import React, {CSSProperties} from "react";
import {
  checklistYesNoOptionTextMap,
  fuelTypeToText, mapChecklistNoYesOptionColor,
  mapChecklistYesNoOptionColor,
  PropertyType
} from "../send/ChecklistTypes";
import locales from "../../locales";

interface Props {
  value: string | undefined;
  type: PropertyType;
  style?: CSSProperties;
}

class ChecklistPropertyLabel extends React.Component<Props, any> {

  public render() {
    const {value, type, style} = this.props;
    if (value) {
      if (type === 'yesNo') {
        return (
          <div
            style={{...style, color: mapChecklistYesNoOptionColor(value)}}
          >
            {checklistYesNoOptionTextMap[value]}
          </div>
        )
      } else if (type === "noYes") {
        return (
          <div
            style={{...style, color: mapChecklistNoYesOptionColor(value)}}
          >
            {checklistYesNoOptionTextMap[value]}
          </div>
        )
      } else if (type === "fuel") {
        return fuelTypeToText[value];
      } else if (type === 'operationHours') {
        return `${value} ${locales.hours}`;
      }

    }
    return null;
  }
}

export default ChecklistPropertyLabel;


// WEBPACK FOOTER //
// ./src/checklist/view/ChecklistPropertyLabel.tsx